<footer>
  <div class="main flex flex-col items-center justify-around gap-4 md:flex-row md:justify-center md:gap-0 h-[24px]">
    <div class="telephone font-normal text-center" *ngIf="!isAld">
      {{ "client_service" | i18n }}:
      <a [href]="'tel:'" target="_blank" class="hover:underline">
        <b class="font-bold">{{ getClientServiceTelephoneStartingFromCaptive() }}</b>
      </a>
    </div>

    <div class="hidden md:block px-4 text-gray-400" *ngIf="!isSmart && !isLynkCo && !isAld">
      |
    </div>

    <div class="telephone font-normal text-center" *ngIf="!isSmart && !isLynkCo && !isAld">
      {{ "roadside_assistance" | i18n }}:
      <a [href]="'tel:'" target="_blank" class="hover:underline">
        <b class="font-bold">{{ getRoadsideAssistanceTelephoneStartingFromCaptive() }}</b>
      </a>
    </div>
  </div>
</footer>

<ald-sub-footer></ald-sub-footer>